import { AppContexts } from "@/app/AppContexts";
import { AuthWrapper } from "@/app/AuthWrapper";
import InvitationManager from "@/components/InvitationManager";
import { WebsiteSelectionModal } from "@/components/WebsiteSelectionModal";
import SecondStageOnboardingModal from "@/components/SecondStageOnboardingModal";
import { Outlet } from "react-router-dom";
import { useState, useEffect } from "react";

export const DashboardLayout = () => {
  const [showSecondStageModal, setShowSecondStageModal] = useState(false);
  const [initialStep, setInitialStep] = useState(1);

  // Listen for the custom event to open the second stage modal
  useEffect(() => {
    const onOpenSecondStage = (e: any) => {
      const step = e?.detail?.initialStep || 1;
      setInitialStep(step);
      setShowSecondStageModal(true);
    };

    window.addEventListener('open-second-stage-onboarding' as any, onOpenSecondStage);
    return () => window.removeEventListener('open-second-stage-onboarding' as any, onOpenSecondStage);
  }, []);

  // Handle URL parameter for showing the modal
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    if (params.get('show_second_stage') === '1') {
      setShowSecondStageModal(true);
    }
  }, []);

  const handleCloseModal = () => {
    setShowSecondStageModal(false);
    // Remove the URL parameter when closing
    const params = new URLSearchParams(window.location.search);
    params.delete('show_second_stage');
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  };

  const handleComplete = () => {
    setShowSecondStageModal(false);
    // Remove the URL parameter when completing
    const params = new URLSearchParams(window.location.search);
    params.delete('show_second_stage');
    window.history.replaceState({}, '', `${window.location.pathname}?${params.toString()}`);
  };

  return (
    <AppContexts withSidebar={true}>
      <AuthWrapper>
        <InvitationManager />
        <Outlet />
        <WebsiteSelectionModal />
        <SecondStageOnboardingModal
          isOpen={showSecondStageModal}
          onClose={handleCloseModal}
          onComplete={handleComplete}
          initialStep={initialStep}
        />
      </AuthWrapper>
    </AppContexts>
  );
};
